/**
 * Canonical service tag labels (footer, vendor defaults, public filters).
 * Must match `barber-backend/src/constants/serviceTags.constant.js`.
 */
export const DEFAULT_SERVICE_TAGS = [
  'Hair Cutting & Styling',
  'Beard Grooming',
  'Hair Coloring',
  'Facial Treatments',
  'Hair Spa',
  'Manicure & Pedicure',
];
